import { Container, Stack } from '@mui/material'
import { Text } from 'ui-kit'
import type { LeadFormRelation } from '../../types/strapi'
import { CmsLeadForm } from './CmsLeadForm'

export type LeadFormBlockProps = {
  title?: string | null
  introduction?: string | null
  lead_form?: LeadFormRelation | null
}

/** `forms.lead-form-block` page-builder block: an optional heading and a CMS lead form. */
export function LeadFormBlock({
  title,
  introduction,
  lead_form: leadForm,
}: LeadFormBlockProps) {
  if (!leadForm?.data) return null

  return (
    <Container maxWidth="xs" sx={{ my: '4rem' }}>
      {title || introduction ? (
        <Stack gap={2} sx={{ mb: 4, textAlign: 'center' }}>
          {title ? (
            <Text variant="h2" component="h2">
              {title}
            </Text>
          ) : null}
          {introduction ? (
            <Text variant="p" component="p">
              {introduction}
            </Text>
          ) : null}
        </Stack>
      ) : null}
      <CmsLeadForm leadForm={leadForm} />
    </Container>
  )
}
